<template>
    <b-container>
        <h1>System Message</h1>

            <b-form-group :class="{ 'text-danger': validation.hasError('message.subject') }">
                <label for="subject">Subject</label>
                <b-form-input id="subject" v-model="message.subject"></b-form-input>
                <div class="error-message">{{ validation.firstError('message.subject') }}</div>
            </b-form-group>
            <b-form-group :class="{ 'text-danger': validation.hasError('message.body') }">
                <label for="body">Body</label>
                <ckeditor :editor="editor" v-model="message.body" :config="editorConfig"></ckeditor>
                <div class="error-message">{{ validation.firstError('message.body') }}</div>
            </b-form-group>
            <b-form-group>
                <label for="set_status">Set Status</label>
                <b-form-select id="set_status" v-model="message.set_status" :options="statusOptions"></b-form-select>
            </b-form-group>
            <b-form-group>
                <label for="user_id">Send to:</label>
                <b-form-select id="ref_id" v-model="message.ref_id" :options="users"></b-form-select>
            </b-form-group>
            <b-form-group :class="{ 'text-danger': validation.hasError('message.published_at') }">
                <label for="published_at">Published At</label>
                <b-row>
                    <b-col cols="6">
                        <DatePicker v-model="message.published_at" date-id="published_at" />
                    </b-col>
                    <b-col cols="6">
                        <b-form-timepicker v-model="message.published_time" locale="en-US" placeholder="Select time"></b-form-timepicker>
                    </b-col>
                </b-row>
                <div class="error-message">{{ validation.firstError('message.published_at') }}</div>
            </b-form-group>
            <b-form-group>
                <label>Clear Read Receipts</label>
                <b-form-select id="clear_read_receipts" v-model="message.clear_read_receipts" :options="clearReadReceiptsOptions"></b-form-select>
            </b-form-group>
            <b-form-group>
                <b-button type="submit" v-if="validation.errors.length === 0" @click="saveSystemMessage" variant="primary">{{button_label}}</b-button>
            </b-form-group>
        
    </b-container>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import MessageDataService from '@/services/MessageDataService';
import UserDataService from '@/services/UserDataService';
import DatePicker from '@/components/DatePicker.vue';
import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;

export default {
    name: "MessageForm",
    components: { DatePicker },
    data() {
        const now = new Date();
        const mm = String(now.getMonth() + 1).padStart(2, '0');
        const dd = String(now.getDate()).padStart(2, '0');
        const yyyy = now.getFullYear();
        const hh = String(now.getHours()).padStart(2, '0');
        const mi = String(now.getMinutes()).padStart(2, '0');
        const ss = String(now.getSeconds()).padStart(2, '0');

        return {
            message: {
                subject: "",
                body: "",
                set_status: 1,
                ref_id: '',
                clear_read_receipts: 0,
                published_at: `${mm}/${dd}/${yyyy}`,
            },
            published_time: `${hh}:${mi}:${ss}`,
            statusOptions: [
                { value: 0, text: 'Inactive' },
                { value: 1, text: 'Active' },
            ],
            clearReadReceiptsOptions: [
                { value: 0, text: 'No' },
                { value: 1, text: 'Yes' },
            ],            
            editor: ClassicEditor,
            editorData: '<p>Content of the editor.</p>',
            editorConfig: {
                height: '200px',
            },
            users: [],
            action: 'create',
            button_label: 'Save and Schedule Message'
        };
    },
    validators: {
        'message.subject': function (value) {
            return Validator.value(value).required('The subject is required');
        },
        'message.published_at': function (value) {
            return Validator.value(value).required('The published date is required');
        },    
        'message.body': function (value) {
            return Validator.value(value).required('The body is required');
        },      
    },
    created() {

        UserDataService.getActiveUsers().then((res) => {

            let users = [];

            users.push({ value: '', text: 'All Users' });
            res.data.forEach(element => {
                users.push({ value: element.value, text: element.text });
            })

            this.users = users;

        });

        if (this.$route.name == 'admin_system_message_edit') {            
            this.action = 'update';
            this.button_label = 'Update Message';
            MessageDataService.getById(this.$route.params.id).then((res) => {

            // Extract time from published_at before date formatting
            if (res.data.published_at) {
                const pubDate = new Date(res.data.published_at);
                if (!isNaN(pubDate)) {
                    const hh = String(pubDate.getHours()).padStart(2, "0");
                    const mi = String(pubDate.getMinutes()).padStart(2, "0");
                    const ss = String(pubDate.getSeconds()).padStart(2, "0");
                    this.published_time = `${hh}:${mi}:${ss}`;
                }
            }

            // Format fields starting with "date_" to MM/DD/YYYY
            Object.keys(res.data).forEach((key) => {
                if (key.startsWith("date_") && res.data[key] || key.endsWith("_at") && res.data[key]) {
                    const date = new Date(res.data[key]);
                    if (!isNaN(date)) {
                        const mm = String(date.getMonth() + 1).padStart(2, "0");
                        const dd = String(date.getDate()).padStart(2, "0");
                        const yyyy = String(date.getFullYear());

                        res.data[key] = `${mm}/${dd}/${yyyy}`;
                    }
                }
            });

                this.message = res.data;
                this.message.clear_read_receipts = 0;
                
            });
        }    
        
    },
    mounted() {
        this.$validate();
    },
    methods: {
        saveSystemMessage() {
            const payload = { ...this.message };
            payload.published_at = this.message.published_at + ' ' + (this.published_time || '08:00:00');

            if (this.action === 'update') {
                MessageDataService.update(payload.id, payload).then(() => {
                    window.location = `/admin/system-messages/?update=true`;
                })
            } else {
                MessageDataService.create(payload).then(() => {
                    window.location = `/admin/system-messages/?create=true`;
                });
            }
        }
    }
};
</script>

<style>
.ck.ck-content:not(.ck-comment__input *) {
    height: 300px;
    overflow-y: auto;
}
</style>